<template>
    <div>
        <div class="headline">
            <div class="level is-mobile">
                <div class="level-left">
                    <h1 class="title is-size-4">My Account</h1>
                </div>
                <div class="level-right">
                    <md-menu>
                        <md-button class="md-icon-button" md-menu-trigger>
                            <md-icon>more_vert</md-icon>
                        </md-button>
                        <md-menu-content>
                            <md-menu-item @click="logout">
                                <md-icon>logout</md-icon>
                                <span>Log Out</span>
                            </md-menu-item>
                            <md-menu-item to="/about">
                                <md-icon>info</md-icon>
                                <span>About</span>
                            </md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </div>
            </div>
            <!-- TODO: Add user details  -->
            <get-verified-prompt v-if="verified !== true" :to="'userMenu'"></get-verified-prompt>
        </div>
        <div class="requests">
            <div class="columns is-gapless is-mobile is-multiline">
                <div v-for="card in cards" class="column is-half">
                    <div class="card"
                         :style='{ backgroundImage: `url("${card.thumb}")` }'
                         @click="goTo(card.id)">
                        <div class="card-content">
                            <p class="title is-size-6 has-text-white">₱ {{card.amount | number}}</p>
                            <p class="subtitle is-size-7 has-text-white">{{card.headline}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <logout-alert :show-dialog.sync="showDialog"></logout-alert>
    </div>
</template>

<script>
    import LogoutAlert from "../components/logout-alert";
    import GetVerifiedPrompt from "../components/get-verified-prompt";
    import bus from '../bus';

    export default {
        name: "UserMenu",
        components: {GetVerifiedPrompt, LogoutAlert},
        data() {
            return {
                cards: [],
                showDialog: false,
                verified: localStorage.getItem('verified')
            }
        },
        methods: {
            goTo(id) {
                this.$router.push({ path: `/requests/${id}` })
            },
            getUserVideos() {
                const vm = this;
                vm.axios.get(`${vm.$host}/users/${localStorage.user}/matches?access_token=${localStorage.token}`)
                .then(function (res) {
                    res.data.forEach(loan => {
                        vm.cards.push({
                            headline: loan.headline,
                            amount: loan.principal,
                            thumb: loan.thumb,
                            id: loan.id
                        })
                    })
                }).catch(function (err) {
                    alert(err);
                })
            },
            logout() {
                const vm = this;
                vm.axios.post(`${vm.$host}/users/logout?access_token=${localStorage.token}`)
                    .then(function (res) {
                        bus.$emit('loginStatus', false);
                        localStorage.removeItem('token');
                        localStorage.removeItem('expiry');
                        localStorage.removeItem('user');
                        vm.showDialog = true;
                    }).catch(function (err) {
                        alert(err)
                    })
            }
        },
        mounted() {
            this.showDialog = false;
            const now = new Date().getTime();
            const refreshTime = localStorage.expiry - 3600000;
            if(!localStorage.token || now > refreshTime) {
                this.$router.push({name: 'login', query: { to: 'userMenu' }})
            } else {
                this.getUserVideos()
            }

        }
    }
</script>

<style scoped>
    .headline {
        padding: 16px;
    }
    .card {
        min-height: 240px;
        height: 100%;
        background-color: #00a86b;
        background-size: cover;
        background-position: center;
    }
    .card-content {
        padding: 16px;
        height: 86%;
        background: linear-gradient(
                hsla(0, 0%, 0%, 0.738) 0%,
                hsla(0, 0%, 0%, 0.541) 19%,
                hsla(0, 0%, 0%, 0.382) 34%,
                hsla(0, 0%, 0%, 0.278) 47%,
                hsla(0, 0%, 0%, 0.194) 56.5%,
                hsla(0, 0%, 0%, 0.126) 64%,
                hsla(0, 0%, 0%, 0.075) 73%,
                hsla(0, 0%, 0%, 0.042) 80.2%,
                hsla(0, 0%, 0%, 0.021) 86.1%,
                hsla(0, 0%, 0%, 0.008) 91%,
                hsla(0, 0%, 0%, 0.002) 95.2%,
                hsla(0, 0%, 0%, 0) 100%
        );
    }
</style>